import { Toaster } from 'react-hot-toast';

export function Toast() {
  return (
    <Toaster
      position="top-center"
      toastOptions={{
        duration: 3000,
        ariaProps: { role: 'status', 'aria-live': 'polite' },
        style: {
          background: '#000000',
          color: '#FFFFFF',
          borderRadius: '12px',
          fontSize: '14px',
          fontFamily: 'Barlow, sans-serif',
        },
        success: {
          iconTheme: { primary: '#FDD238', secondary: '#000000' },
        },
        error: {
          ariaProps: { role: 'alert', 'aria-live': 'assertive' },
          iconTheme: { primary: '#ef4444', secondary: '#FFFFFF' },
        },
      }}
    />
  );
}
